// Fetch Images
export const FETCH_USER_IMAGES_START = 'FETCH_USER_IMAGES_START';
export const FETCH_USER_IMAGES_FAILURE = 'FETCH_USER_IMAGES_FAILURE';
export const FETCH_USER_IMAGES_SUCCESS = 'FETCH_USER_IMAGES_SUCCESS';

// Upload Images
export const UPDATE_UPLOAD_QUEUE = 'UPDATE_UPLOAD_QUEUE';
export const UPLOAD_IMAGES_START = 'UPLOAD_IMAGES_START';
export const UPLOAD_IMAGES_FAILURE = 'UPLOAD_IMAGES_FAILURE';
export const UPLOAD_IMAGES_SUCCESS = 'UPLOAD_IMAGES_SUCCESS';

// Clear Image Manager
export const RESET_MANAGER_STATE = 'RESET_MANAGER_STATE';

// Copy Images to Team
export const COPY_IMAGES_TO_TEAMS_START = 'COPY_IMAGES_TO_TEAMS_START';
export const COPY_IMAGES_TO_TEAMS_FAILURE = 'COPY_IMAGES_TO_TEAMS_FAILURE';
export const COPY_IMAGES_TO_TEAMS_SUCCESS = 'COPY_IMAGES_TO_TEAMS_SUCCESS';

// Delete Image
export const DELETE_IMAGE_START = 'DELETE_IMAGE_START';
export const DELETE_IMAGE_FAILURE = 'DELETE_IMAGE_FAILURE';
export const DELETE_IMAGE_FROM_CATEGORY_SUCCESS = 'DELETE_IMAGE_FROM_CATEGORY_SUCCESS';

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const REPORT_ERROR = 'REPORT_ERROR';
